/*
Replace
dishRecipeIngredient with your resource Name :) Take care about different writings!
/!\ DishRecipeIngredient dishRecipeIngredient DishRecipeIngredients dishRecipeIngredients /!\
Keep an eye on pluralized namings in here :)

*/
/**
 *  Sagas for the DishRecipeIngredients resource managment using Swagger client
 *
 * Each saga watcher intercepts a trigger action, does the asyncrhonous work in the respective worker saga and dispatches a success or a failure action.
 * Fetch calls are made via the swagger tags interface requests
 *
 */

import { call, put, takeEvery, select } from "redux-saga/effects";
import buildHeaders from "../../utils/buildHeaders";
import { actions } from "./index";
import { storeIncluded } from "../dictionarySagas";
import apiClient, { applyHeaders } from "../../utils/apiSwaggerRequest";
import DataLayerHelper from "../../utils/dataLayer";

/** Worker Sagas */

/** List Saga
 *  @description: connects to the getDishRecipeIngredient operation
 */
export function* list(action) {
  const { locationId, date_start, date_end } = action.payload;
  const currentUser = yield select((state) => state.professionalAccount.currentUser);
  let headers = buildHeaders(currentUser);

  try {
    const SwaggerClient = yield call(apiClient);
    const payload = yield call(
      SwaggerClient.apis.DishRecipeIngredients.listDishRecipeIngredients,
      { location_id: locationId, date_start: date_start, date_end: date_end },
      { requestInterceptor: applyHeaders(headers) }
    );
    if (payload.obj.included)
      yield* storeIncluded({ payload: payload.obj.included });
    yield put({ type: actions.listSuccess, payload: payload });
  } catch (e) {
    yield put({ type: actions.listFail, payload: e });
    DataLayerHelper.addErrorEvent(
      "Load DishRecipeIngredient List",
      e.error || e.message || "DishRecipeIngredient Error"
    );
  }
}

/** Show Saga
 *  @description: connects to the showDishRecipeIngredient operation
 *  @param {number} action.payload the DishRecipeIngredient id
 */
export function* show(action) {
  const { dishRecipeIngredientId, locationId } = action.payload;
  const currentUser = yield select((state) => state.professionalAccount.currentUser);
  let headers = buildHeaders(currentUser);
  try {
    const SwaggerClient = yield call(apiClient);
    const payload = yield call(
      SwaggerClient.apis.DishRecipeIngredients.showDishRecipeIngredient,
      { id: dishRecipeIngredientId, location_id: locationId },
      { requestInterceptor: applyHeaders(headers) }
    );
    yield* storeIncluded({ payload: payload.obj.included });
    yield put({ type: actions.showSuccess, payload: payload.obj.data });
  } catch (e) {
    yield put({ type: actions.showFail, payload: e });
  }
}

export function* create(action) {
  const { location_id, dishRecipeIngredient } = action.payload;
  const currentUser = yield select((state) => state.professionalAccount.currentUser);
  let headers = buildHeaders(currentUser);
  try {
    const SwaggerClient = yield call(apiClient);
    let payload = yield call(
      SwaggerClient.apis.DishRecipeIngredients.createDishRecipeIngredient,
      { location_id, dishRecipeIngredient },
      { requestInterceptor: applyHeaders(headers) }
    );

    yield put({ type: actions.createSuccess, payload: payload.obj.data });

    if (payload.obj.included) {
      yield* storeIncluded({ payload: payload.obj.included });
    }

    if (action.payload.callback) {
      action.payload.callback();
    }

    DataLayerHelper.addSuccessEvent(
      "Create DishRecipeIngredient",
      `data to log, maybe id?`
    );
  } catch (e) {
    yield put({ type: actions.createFail, payload: e });
  }
}

export function* update(action) {
  const currentUser = yield select((state) => state.professionalAccount.currentUser);
  let headers = buildHeaders(currentUser);
  let values = action.payload;
  try {
    const SwaggerClient = yield call(apiClient);
    let payload = yield call(
      SwaggerClient.apis.DishRecipeIngredients.updateDishRecipeIngredient,
      {
        id: values.id,
        dishRecipeIngredient: values,
      },
      { requestInterceptor: applyHeaders(headers) }
    );

    yield put({ type: actions.updateSuccess, payload: payload.body });

    yield* storeIncluded({ payload: payload.obj.included });

    if (action.payload.callback) {
      action.payload.callback();
    }

    DataLayerHelper.addSuccessEvent(
      "Updated DishRecipeIngredient",
      `${values.id}`
    );
  } catch (e) {
    yield put({ type: actions.updateFail, payload: e });
  }
}

/**
 * Saga Watchers
 * The exported list of sagas registered. When one of the action types is dispatched
 * the related worker saga is invoked.
 * Each saga is executed in a different thread
 */
function* transactionsSaga() {
  yield takeEvery(actions.list, list);
  yield takeEvery(actions.show, show);
  yield takeEvery(actions.create, create);
  yield takeEvery(actions.update, update);
}
export default transactionsSaga;
